import React, { Component } from "react"
import { TextField, Dialog, FlatButton } from "material-ui"
import strings from "../../localization/strings"
import { IFilter } from "../../models"
import AppStateStore from "../../stores/AppStateStore"

interface IProps {
    addFilterTemplateLabel: string
    editFilterTemplateLabel: string
    editFilterTemplate: IFilter
    existingFilterTemplates: IFilter[]
    handleSave(name: string): void
    handleClose(): void
    handleDeleteFilterTemplate(filterTemplateId: string): void
    children: React.ReactElement
}
interface IState {
    name: string
    errorName: string
    errorChildren: boolean
}

export default class AddFilterTemplateDialog extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            name: props.editFilterTemplate ? props.editFilterTemplate.Name : "",
            errorName: null,
            errorChildren: false
        }
    }

    checkValidate() {
        let isValidate = true
        if (!this.state.name.trim()) {
            this.setState({ errorName: strings.This_field_is_required })
            isValidate = false
        }
        else if (this.props.existingFilterTemplates.filter(i => i.Id !== (this.props.editFilterTemplate ? this.props.editFilterTemplate.Id : null)).find(i => i.Name === this.state.name.trim())) {
            this.setState({ errorName: strings.Name_is_duplicated })
            isValidate = false
        }
        else {
            this.setState({ errorName: null })
        }
        return isValidate
    }

    render() {
        return (
            <Dialog
                open
                autoScrollBodyContent
                title={
                    <h2 style={{ color: "#616161" }}>
                        {this.props.editFilterTemplate ? this.props.editFilterTemplateLabel : this.props.addFilterTemplateLabel}
                    </h2>
                }
                titleStyle={{ fontWeight: "bold" }}
                actions={[
                    <FlatButton
                        label={strings.Delete_Filter}
                        primary
                        style={{ float: "left" }}
                        onClick={() => AppStateStore.setConfirmDialogContent({
                            content: strings.Are_you_sure_you_want_to_delete_this_filter,
                            confirm: () => this.props.handleDeleteFilterTemplate(this.props.editFilterTemplate.Id)
                        })}
                        disabled={!this.props.editFilterTemplate}
                    />,
                    <FlatButton
                        label={strings.CANCEL}
                        secondary
                        onClick={this.props.handleClose}
                    />,
                    <FlatButton
                        label={strings.Save_Filter}
                        primary
                        onClick={() => this.checkValidate() && !this.state.errorChildren &&
                            this.props.handleSave(this.state.name.trim())
                        }
                    />
                ]}
            >
                <p style={{ color: "#616161", margin: 0 }}>{this.props.editFilterTemplate ? strings.Edit_Filter_Template_Title_Intro : strings.Create_Filter_Template_Title_Intro}</p>
                <div>
                    <TextField
                        floatingLabelText={strings.Filter_Name}
                        value={this.state.name}
                        onChange={(e, name) => this.setState({ name }, () => this.checkValidate())}
                        errorText={this.state.errorName}
                        errorStyle={{ position: "absolute", bottom: -10 }}
                        style={{ marginTop: -15 }}
                        fullWidth={true}
                    />
                </div>
                <div style={{ display: "flex", flexDirection: "column" }}>
                    {React.cloneElement(this.props.children as React.ReactElement,
                        {
                            checkValidate: isValidate =>
                                this.setState({ errorChildren: !isValidate })
                        }
                    )}
                </div>
            </Dialog>
        )
    }
}
